import React from "react";
import "../styles/Layout.css";
import "../styles/Components.css";
import "../styles/Screens.css";

const DatenschutzScreen = ({ onBack }) => {
  return (
    <div className="legal-screen">
      <button className="back-button" onClick={onBack}>
        ← Zurück
      </button>

      <div className="legal-content">
        <h1 className="legal-title">Datenschutzerklärung</h1>

        <section className="legal-section">
          <h2>1. Verantwortlicher</h2>
          <p>Adrian Hufnagl</p>
          <p>hello@cyberhoof.at</p>
          <p>Bindergasse 11/30, 1090 Wien, AUSTRIA</p>
        </section>

        <section className="legal-section">
          <h2>2. Hosting</h2>
          <p>Diese Website wird bei Netlify, Inc. gehostet.</p>
          <p>
            Beim Besuch dieser Website erfasst Netlify automatisch Informationen
            in sogenannten Server-Logfiles, die Ihr Browser automatisch
            übermittelt. Dies sind insbesondere:
          </p>
          <ul>
            <li>IP-Adresse</li>
            <li>Datum und Uhrzeit der Anfrage</li>
            <li>Browsertyp und -version</li>
            <li>verwendetes Betriebssystem</li>
            <li>Referrer-URL</li>
          </ul>
          <p>
            Die Verarbeitung dieser Daten erfolgt zum Zweck der technischen
            Bereitstellung, Sicherheit und Stabilität der Website.
          </p>

          <div className="legal-block highlight">
            <h3>RECHTSGRUNDLAGE</h3>
            <p>
              Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem
              sicheren und funktionsfähigen Webauftritt).
            </p>
          </div>
        </section>

        <section className="legal-section">
          <h2>3. Cookies &amp; Tracking</h2>
          <p>
            Diese Website verwendet keine Cookies und keine Analyse- oder
            Tracking-Tools.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. SSL-/TLS-Verschlüsselung</h2>
          <p>
            Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw.
            TLS-Verschlüsselung.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Ihre Rechte</h2>
          <p>
            Sie haben das Recht auf Auskunft, Berichtigung, Löschung,
            Einschränkung der Verarbeitung sowie Widerspruch gegen die
            Verarbeitung Ihrer personenbezogenen Daten.
          </p>
          <p>
            Zudem besteht ein Beschwerderecht bei der österreichischen
            Datenschutzbehörde (DSB).
          </p>
        </section>
      </div>
    </div>
  );
};

export default DatenschutzScreen;
